<div class="widget-handler"></div>
<div
  class="wrapper"
  *ngIf="accessCollection && loaded; else noAccessCollection"
  data-cy="collection-widget"
  [ngClass]="{ smallScreen: isSmallScreen }"
  (click)="focusWidget(selectedIndex)"
>
  <widget-title
    *ngIf="collection; else loadingTitle"
    [sectionButtons]="{ sort: canEdit && collection.kind !== 'Static', contextMenu: true }"
    [currentSort]="currentSort"
    [contextMenuOpened]="contextMenuOpened"
    [movedWidget]="movedWidget"
    (searchSort)="updateSort($event)"
    (openContextMenu)="openContextMenu($event)"
    (sortPopupOpened)="sortPopupOpened = $event"
    [allowWidgetHandler]="false"
  >
    <section class="widget-title-content" [class.sort]="canEdit && collection.kind !== 'Static'">
      <collection-item
        class="collection-title"
        [contextMenu]="contextMenu"
        [sortPopupOpened]="sortPopupOpened"
        [collection]="collection"
        [resultAmount]="resultsCount"
        [attr.data-index]="'0'"
        [viewMode]="'widget'"
        [tabId]="settings?.tabId"
        [layoutMode]="layoutMode"
        [showResultSections]="{
          showBullets: false,
          showSubtitleInSecondLine: false,
        }"
        (contextOpen)="contextMenuOpened = true"
        (contextClose)="contextMenuOpened = false"
        (layoutChanged)="layoutChanged($event)"
      >
      </collection-item>
    </section>
  </widget-title>
  <ng-template #loadingTitle>
    <widget-title title="collection" navigateUrl="collection" label="collection"></widget-title>
  </ng-template>

  <div class="widget-body">
    <widget-no-result
      *ngIf="!isLoading && displayedContext.items && displayedContext.items.length == 0 && collection; else resultList"
      [title]="emptyStateModel.title"
      [imgModel]="emptyStateModel.imgModel"
    >
    </widget-no-result>
    <ng-template #resultList>
      <search-results-list
        [displayedContext]="displayedContext"
        [items]="displayedContext?.items"
        [layoutMode]="layoutMode"
        [isOwner]="false"
        [smallView]="true"
        [maxColumnsInScreen]="true"
        [removeFocus]="true"
        (nextPage)="prepareNextPage($event)"
        (onDynamicCommand)="onDynamicCommand($event)"
        [listView]="{ isEditable: false, isDraggable: false, limitResults: !collection.kind || collection?.kind === 'Live' }"
        [loadingItem]="loadingItem"
        [listName]="'static_collections'"
        [componentFocused]="isFocused"
        [resizeChange]="widgetResizeChange$ | async"
        [displayBg]="false"
        [customScrollHeight]="scrollHeight"
        (mouseover)="keyboardOn = false"
        [defaultResultSections]="{
          showAvatarList: false,
          showSnippet: false,
        }"
        [showAlwaysDefaultResultSections]="true"
        [searchId]="searchId"
      ></search-results-list>
    </ng-template>
    <div class="preview-error" *ngIf="!collection">
      <u-icon class="preview-error-icon" [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }"> </u-icon>
      <p class="preview-error-message">There was a problem uploading the collection shared with you.<br />Please try again.</p>
      <u-button label="Try again" type="primary" [styles]="{ width: '90' }" (onClick)="tryAgain()"></u-button>
    </div>

    <div class="ghost-container" *ngIf="isLoading">
      <result-ghost *ngFor="let i of 8 | fill"></result-ghost>
    </div>
  </div>
</div>

<ng-template #warningPopupContent>
  <div class="warning-popup">
    <u-checkbox [checked]="false" [binary]="true" (click)="onClickCheckbox($event)"> </u-checkbox>
    <div class="text">Do not show this again</div>
  </div>
</ng-template>

<ng-template #noAccessCollection>
  <ng-container *ngIf="loaded">
    <u-icon
      *ngIf="movedWidget"
      class="dragging-icon dragging-icon-no-access"
      [model]="{ type: 'font', value: 'icon-dragging-ind' }"
      [styles]="{ fontSize: '12px' }"
    ></u-icon>
    <div class="no-access-container">
      <div class="no-access">
        <u-icon class="no-access-icon" [model]="{ type: 'font', value: 'icon-lock-light' }" [styles]="{ fontSize: '24px' }"> </u-icon>
        <div class="text">
          <span class="title">No access</span>
          <span class="sub-title">Contact your administrator</span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
